import { render, staticRenderFns } from "./Tollfree.vue?vue&type=template&id=2a0fc864"
import script from "./Tollfree.vue?vue&type=script&lang=js"
export * from "./Tollfree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports